import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { modalClose } from '../../../../layout/redux/layoutActions'
import { Button, Modal } from '../../../../components'

import './competitorgapdetailmodal.scss'

const formatarPercentual = valor => {
  if (valor === null || valor === undefined) return '-'

  return `${Number(valor).toFixed(1)}%`
}

const formatarNumero = valor => {
  if (valor === null || valor === undefined) return '-'

  return Number(valor).toLocaleString('pt-BR')
}

const CompetitorGapDetailModal = ({ gap, detalhe, loadingDetalhe, nls }) => {
  const dispatch = useDispatch()
  const { statusModal } = useSelector(state => state.layoutState)

  const informacoesGerais = detalhe?.informacoesGerais
  const problemaEncontrado = detalhe?.problemaEncontrado
  const indicadoresRelacionados = detalhe?.indicadoresRelacionados || []
  const evidencias = detalhe?.evidencias || []
  const marketingAngles = detalhe?.marketingAngles || []

  const handleCloseModal = () => {
    dispatch(modalClose())
  }

  return (
    <Modal
    cy='competitorgaps-detail'
      title={nls.detail}
      size='large'
      open={statusModal === 'competitorGapDetail'}
      close={() => handleCloseModal()}
      closeText={nls.close}
    >
      <div
  className='modal-competitor-gap-detail'
  data-cy='competitorgaps-detail-content'
  data-cy-id={gap?.gapId}
>
        {loadingDetalhe ? (
          <div
  className='modal-competitor-gap-detail-loading'
  data-cy='competitorgaps-detail-loading'
>
            {nls.loading || 'Carregando...'}
          </div>
        ) : !detalhe ? (
          <div
  className='modal-competitor-gap-detail-empty'
  data-cy='competitorgaps-detail-empty'
>
  {nls.emptyDetail}
</div>
        ) : (
          <>
            <h3
  className='modal-competitor-gap-detail-title'
  data-cy='competitorgaps-detail-title'
>
              {gap?.titulo || `${nls.detail} #${informacoesGerais?.numeroGapProjeto || '-'}`}
            </h3>

            <div
  className='modal-competitor-gap-detail-section'
  data-cy='competitorgaps-detail-section'
  data-cy-key='general'
>
              <h4>{nls.generalInformation}</h4>

              <div className='modal-competitor-gap-detail-grid'>
                <div className='modal-competitor-gap-detail-item'>
                  <span>{nls.competitor}:</span>
                  <strong>{informacoesGerais?.empresaConcorrente || '-'}</strong>
                </div>

                <div className='modal-competitor-gap-detail-item'>
                  <span>{nls.opportunityType}:</span>
                  <strong>{informacoesGerais?.opportunityType || '-'}</strong>
                </div>

                <div className='modal-competitor-gap-detail-item'>
                  <span>{nls.opportunityName}:</span>
                  <strong>{informacoesGerais?.opportunityName || '-'}</strong>
                </div>

                <div className='modal-competitor-gap-detail-item'>
                  <span>{nls.period}:</span>
                  <strong>{informacoesGerais?.tipoPlano || '-'}</strong>
                </div>

                <div className='modal-competitor-gap-detail-item'>
                  <span>{nls.scope}:</span>
                  <strong>{informacoesGerais?.escopo || '-'}</strong>
                </div>

                <div className='modal-competitor-gap-detail-item'>
                  <span>{nls.status}:</span>
                  <strong>{informacoesGerais?.status || '-'}</strong>
                </div>

                <div className='modal-competitor-gap-detail-item'>
                  <span>{nls.analysisPeriod}:</span>
                  <strong>
                    {informacoesGerais?.dataInicioAnalise || '-'} - {informacoesGerais?.dataFimAnalise || '-'}
                  </strong>
                </div>

                <div className='modal-competitor-gap-detail-item'>
                  <span>{nls.validUntil}:</span>
                  <strong>{informacoesGerais?.validoAte || '-'}</strong>
                </div>
              </div>
            </div>

            <div
  className='modal-competitor-gap-detail-section'
  data-cy='competitorgaps-detail-section'
  data-cy-key='problem'
>
              <h4>{nls.problemFound}</h4>

              <div className='modal-competitor-gap-detail-kpis'>
                <div className='modal-competitor-gap-detail-kpi'>
                  <span>{nls.negativeCommentsCompetitor}</span>
                  <strong>{formatarNumero(problemaEncontrado?.comentariosNegativosConcorrente)}</strong>
                </div>

                <div className='modal-competitor-gap-detail-kpi'>
                  <span>{nls.negativeCommentsClient}</span>
                  <strong>{formatarNumero(problemaEncontrado?.comentariosNegativosCliente)}</strong>
                </div>

                <div className='modal-competitor-gap-detail-kpi'>
                  <span>{nls.absoluteGap}</span>
                  <strong>{formatarNumero(problemaEncontrado?.gapAbsoluto)}</strong>
                </div>

                <div className='modal-competitor-gap-detail-kpi'>
                  <span>{nls.percentualGap}</span>
                  <strong>{formatarPercentual(problemaEncontrado?.gapPercentual)}</strong>
                </div>
              </div>
            </div>

            <div
  className='modal-competitor-gap-detail-section'
  data-cy='competitorgaps-detail-section'
  data-cy-key='indicators'
>
              <h4>{nls.relatedIndicators}</h4>

              {indicadoresRelacionados.length > 0 ? (
                <div
  className='modal-competitor-gap-detail-table'
  data-cy='competitorgaps-indicators'
>
                  <div className='modal-competitor-gap-detail-table-header'>
                    <span>{nls.indicator}</span>
                    <span>{nls.frequency}</span>
                    <span>{nls.percentual}</span>
                  </div>

                  {indicadoresRelacionados.map((item, index) => (
                    <div
  key={`${item.indicador}-${index}`}
  className='modal-competitor-gap-detail-table-row'
  data-cy='competitorgaps-indicator'
>
                      <span>{item.indicador || '-'}</span>
                      <span>{formatarNumero(item.frequencia)}</span>
                      <span>{formatarPercentual(item.percentual)}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <div className='modal-competitor-gap-detail-empty'>
                  {nls.noRelatedIndicators}
                </div>
              )}
            </div>

            <div
  className='modal-competitor-gap-detail-section'
  data-cy='competitorgaps-detail-section'
  data-cy-key='evidence'
>
              <h4>{nls.evidences}</h4>

              {evidencias.length > 0 ? (
                <div
  className='modal-competitor-gap-detail-evidences'
  data-cy='competitorgaps-evidences'
>
                  {evidencias.map(evidencia => (
                    <div
  key={evidencia.comentarioId}
  className='modal-competitor-gap-detail-evidence'
  data-cy='competitorgaps-evidence'
  data-cy-id={evidencia.comentarioId}
>
                      <div className='modal-competitor-gap-detail-evidence-meta'>
                        <strong>{evidencia.canalPesquisa || '-'}</strong>
                        <span>{evidencia.dataComentario || '-'}</span>
                      </div>

                      <p>{evidencia.trechoComentario || '-'}</p>
                    </div>
                  ))}
                </div>
              ) : (
                <div className='modal-competitor-gap-detail-empty'>
                  {nls.noEvidences}
                </div>
              )}
            </div>

            <div
  className='modal-competitor-gap-detail-section'
  data-cy='competitorgaps-detail-section'
  data-cy-key='marketing-angles'
>
              <h4>{nls.marketingAngles}</h4>

              {marketingAngles.length > 0 ? (
                <div
  className='modal-competitor-gap-detail-angles'
  data-cy='competitorgaps-marketing-angles'
>
                  {marketingAngles.map(angle => (
                    <div
  key={angle.ordemExibicao}
  className='modal-competitor-gap-detail-angle'
  data-cy='competitorgaps-marketing-angle'
>
                      <h5>{angle.tituloAngle || '-'}</h5>

                      <div className='modal-competitor-gap-detail-angle-item'>
                        <span>{nls.structuralWeakness}:</span>
                        <p>{angle.fragilidadeEstrutural || '-'}</p>
                      </div>

                      <div className='modal-competitor-gap-detail-angle-item'>
                        <span>{nls.strategicInterpretation}:</span>
                        <p>{angle.interpretacaoEstrategica || '-'}</p>
                      </div>

                      <div className='modal-competitor-gap-detail-angle-item'>
                        <span>{nls.narrative}:</span>
                        <p>{angle.narrativa || '-'}</p>
                      </div>

                      <div className='modal-competitor-gap-detail-angle-tone'>
                        {nls.tone}: {angle.tom || '-'}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className='modal-competitor-gap-detail-empty'>
                  {nls.noMarketingAngles}
                </div>
              )}
            </div>

            <div className='modal-competitor-gap-detail-actions'>
                <Button
  data-cy='competitorgaps-detail-close'
  data-cy-effect='read'
  color='primary'
  onClick={() => handleCloseModal()}
>
  {nls.close}
</Button>
            </div>

          </>
        )}
      </div>
    </Modal>
  )
}

export default CompetitorGapDetailModal